import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  useAppDispatch,
  useAppSelector,
} from 'v2/resources/hooks/useAppSelector';
import { useQueryHealthAnalysis } from 'v2/resources/hooks/services/useGraphics';
import { SelectChangeEvent } from '@mui/material';
import {
  IResponseHealthMortality,
  IResponseHealthMortalityInfo,
} from 'v2/resources/types/graphics';
import { filteredDataGraphic } from 'v2/resources/utils/filteredDataGraphic';
import { setGraphicHealthAnalysis } from 'v2/store/dataChat/slice';

const useHealthAnalysis = () => {
  const dispatch = useAppDispatch();
  const { selectedCycle } = useAppSelector((state) => state.selectedCycle);
  const { nameProperty } = useAppSelector((state) => state.nameProperty);

  const [healthMeasuresData, setHealthMeasuresData] =
    useState<IResponseHealthMortality>();
  const [selectedNurseries, setSelectedNurseries] = useState<string>('default');
  const [selectedParameters, setSelectedParameters] =
    useState<IResponseHealthMortalityInfo[]>();

  const { data: dataHealthAnalysis } = useQueryHealthAnalysis(
    selectedCycle?.id
  );

  const handleSelectedInputNurseries = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;
    if (String(value).includes('default')) {
      return;
    }
    setSelectedNurseries(value as string);
  };

  const handleLoadData = useCallback(() => {
    setSelectedNurseries('');
    if (!dataHealthAnalysis) return;

    setHealthMeasuresData(dataHealthAnalysis);

    if (dataHealthAnalysis.labels.length === 0) {
      setSelectedNurseries('default');
      return;
    }
    setSelectedNurseries(dataHealthAnalysis.labels[0] ?? '');
    dispatch(setGraphicHealthAnalysis(dataHealthAnalysis));
  }, [dataHealthAnalysis, nameProperty]);

  const optionsnNurseries = useCallback(() => {
    const defaultOption = [
      {
        id: 1,
        label: 'Viveiros',
        value: 'default',
      },
      {
        id: 2,
        label: 'Viveiros',
        value: 'default2',
      },
    ];
    if (!dataHealthAnalysis) return defaultOption;

    if (dataHealthAnalysis.labels.length === 0) return defaultOption;

    return [
      ...[defaultOption[0]],
      ...dataHealthAnalysis?.labels.map((label, index) => ({
        id: index + 1,
        label: label,
        value: label,
      })),
    ];
  }, [dataHealthAnalysis]);

  const optionsParameters = useMemo(() => {
    if (!healthMeasuresData) return [];

    const result = filteredDataGraphic(healthMeasuresData, selectedNurseries);
    setSelectedParameters(result);
    return result;
  }, [healthMeasuresData, selectedNurseries]);

  useEffect(() => {
    handleLoadData();
  }, [handleLoadData]);
  return {
    optionsParameters,
    optionsnNurseries: optionsnNurseries(),
    selectedNurseries,
    selectedParameters,

    setSelectedParameters,
    handleSelectedInputNurseries,
  };
};

export default useHealthAnalysis;
